import React from 'react';
import { Stack } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import { useApiContext } from '../Hooks/useApiContext';

function LogOnEnter(props) {
    const { endpoints } = useApiContext();
    const [logAction] = endpoints.logUserAction.useMutation();

    async function handleEnterView(inView) {
        if (inView) {
            await logAction({
                action: props.action,
                data: props.data,
            });
        }
    }

    const { ref } = useInView({
        triggerOnce: true,
        threshold: 0.5,
        onChange: handleEnterView,
    });

    return (
        <Stack ref={ref}>
            { props.children }
        </Stack>
    );
}

export default LogOnEnter;
